export const comparer = (compareTo) => {
    return (current) => {
        return compareTo.filter((el) => el.value == current.value && el.value == current.value).length == 0;
    }
}